export default function consolidateData(data, moduleDam, elementType) {
  const result = [];
  const pushItems = ({
    claim,
    moduleName,
    moduleId,
    elementType,
    parentClaim,
  }) => {
    // 🔴 Skip if mustUse is not true
    // if (!claim.mustUse) return;

    const base = {
      moduleName,
      elementId:
        elementType === "claims"
          ? claim.claimName
          : elementType === "components"
          ? claim.componentDocNumber ||
            claim.claimName ||
            claim.reusableTextName
          : claim.reusableTextName,
      used: false,
      moduleId,
      elementType,
      count:0 //to test the content used how many times
    };

    const createId = (type, extra = "") => {
      const idCreation = {
        claims: parentClaim
          ? `${moduleId}-${parentClaim}-${claim.claimName}-${type}${
              extra ? "-" + extra : ""
            }`
          : `${moduleId}-${claim.claimName}-${type}${extra ? "-" + extra : ""}`,
        reusableTexts: `${moduleId}-${claim.reusableTextName}-${type}${
          extra ? "-" + extra : ""
        }`,
        components: parentClaim
          ? `${moduleId}-${parentClaim}-${claim.claimName}-${type}${
              extra ? "-" + extra : ""
            }`
          : `${moduleId}-${claim.componentDocNumber}-${type}${
              extra ? "-" + extra : ""
            }`,
      };
      return idCreation[elementType];
    };
    if (claim.matchText) {
      result.push({
        ...base,
        id: createId("matchText"),
        attribute: "matchText",
        content: claim.matchText,
      });
    }

    if (claim.matchTextVariants) {
      claim.matchTextVariants?.forEach((variant) => {
        result.push({
          ...base,
          id: createId("variant", variant.id),
          attribute: "matchTextVariant",
          content: variant.matchText,
        });
      });
    }

    if (claim.footnotes) {
      result.push({
        ...base,
        id: createId("footnote"),
        attribute: "footnote",
        content: claim.footnotes,
      });
    }

    claim.abbreviation?.split(";").forEach((abbr, index) => {
      const value = abbr.trim();
      if (!value) return; // skip empty values

      result.push({
        ...base,
        id: createId("abbreviation", index + 1),
        attribute: "abbreviation",
        content: value,
      });
    });

    if (claim.references) {
      claim.references?.forEach((ref) => {
        result.push({
          ...base,
          id: createId("reference", ref.id),
          attribute: "reference",
          content: ref.documentName,
          documentUrl: ref.documentUrl,
        });
      });
    }

    if (claim.title) {
      result.push({
        ...base,
        id: createId("title"),
        attribute: "Title",
        content: claim.title,
      });
    }

    if (claim.componentUrl) {
      result.push({
        ...base,
        id: createId("componentUrl"),
        content: claim.componentUrl,
        attribute: "Image",
      });
    }
  };

  data.forEach((mainClaim) => {
    // ✅ Only include main claim if mustUse === true
    if (mainClaim.mustUse) {
      if (mainClaim.mustUse) {
        pushItems({
          claim: mainClaim,
          moduleName: "mainClaim",
          moduleId: moduleDam,
          elementType: elementType,
        });
      }

      // ✅ Only include related claim if mustUse === true
      mainClaim.relatedClaims?.forEach((related) => {
        pushItems({
          claim: related,
          moduleName: "relatedClaim",
          moduleId: moduleDam,
          elementType: elementType,
          parentClaim: mainClaim.claimName || mainClaim.componentDocNumber,
        });
      });

      //reusable text under component
      mainClaim.relatedReusableTexts?.forEach((related) => {
        pushItems({
          claim: related,
          moduleName: "relatedReusableText",
          moduleId: moduleDam,
          elementType: elementType,
          parentClaim: mainClaim.claimName || mainClaim.componentDocNumber,
        });
      });
    }
  });

  // 🔹 Sort by elementId before returning
  result.sort((a, b) => {
    if (a.elementId < b.elementId) return -1;
    if (a.elementId > b.elementId) return 1;
    return 0;
  });

  return result;
}
